<section [formGroup]="personal_info">
  <mat-form-field>
    <mat-select placeholder="Province" required formControlName="province">
    <ng-container *ngFor="let province of province.list|async">
      <mat-option [value]="province.id">
        {{province.name}}
      </mat-option>
    </ng-container>
    </mat-select>
    <mat-error *ngIf="personal_info.get('province').hasError('required')">Required.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-select placeholder="City" required formControlName="city">
    <ng-container *ngFor="let city of city.list|async">
      <mat-option [value]="city.id" *ngIf="city.province === personal_info.get('province').value">
        {{city.name}}
      </mat-option>
    </ng-container>
    </mat-select>
    <mat-error *ngIf="personal_info.get('city').hasError('required')">Required.</mat-error>
  </mat-form-field>
</section>
